import { tw } from 'utils/classnames'

const variantClasses = {
  default: 'transition-transform hover:scale-[104%] active:scale-[102%]',
}

export function Button({
  variant,
  ...props
}: React.ComponentProps<'button'> & {
  variant?: keyof typeof variantClasses
  withColorExperiment?: boolean
}) {
  return (
    <button
      type="button"
      {...props}
      className={tw(
        'flex w-full items-center justify-center rounded-[8px] border-0 px-[8px] py-[16px] text-[15px] font-[600] leading-[23.10px] text-[#fff] shadow-xl outline-none transition-all',
        '!bg-[#8559F9] disabled:!bg-[#8559F9]/50',
        variantClasses[variant ?? 'default'],
        props.className,
      )}
    />
  )
}
